export default {
  events: {
    title: "Events",
    eventExplain: "If you want to configure user events, Admin events or Event listeners, please enter <1>Event configs</1> page realm settings to configure.",
    eventConfigs: "Event configs",
    userEvents: "User events",
    adminEvents: "Admin events",
    searchForUserEvent: "Search user event",
    searchForAdminEvent: "Search admin event",
    refresh: "Refresh",
    emptyEvents: "No events logged",
    emptyEventsInstructions: "Configure event logging in the realm settings",
    time: "Time",
    user: "User",
    userId: "User ID",
    username: "User name",
    email: "Email",
    eventType: "Event type",
    ipAddress: "IP address",
    client: "Client",
    dateFrom: "Date(from)",
    dateTo: "Date(to)",
    searchUserEventsBtn: "Search events",
    searchAdminEventsBtn: "Search admin events",
    realm: "Realm",
    resourcePath: "Resource path",
    resourceType: "Resource type",
    resourceTypes: "Resource types",
    operationType: "Operation type",
    operationTypes: "Operation types",
    auth: "Auth",
    attribute: "Attribute",
    value: "Value",
    representation: "Representation",
    noUserDetails: "No user details"
  }
};
